// Escape a value for safe interpolation into an HTML string. Covers & < > " '
// so it's safe inside quoted attributes too (not just text content).
export function esc(s) {
  return String(s ?? "").replace(/[&<>"']/g, c => (
    { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
  ))
}

// Shared label/value row for server-shaped map details. Centralizing both the
// escaping and markup keeps popup and panel builders on one XSS boundary.
export function row(label, value) {
  return `<div class="flex justify-between border-b border-gray-50 py-1.5"><span class="text-gray-500">${esc(label)}</span><span class="text-gray-900">${esc(value)}</span></div>`
}
